import React, { useEffect, useState } from 'react'


import { usePerfil } from '../../../../../hooks/usePerfil';
import { Perfil } from '../../../../../types/Perfil';

export const BuscarPerfil = () => {
    const { perfilInitial, buscarPerfiles } = usePerfil();
    const [filtroPerfil, setFiltroPerfil] = useState<Perfil>(perfilInitial);
    const [newPerfil] = useState<Perfil>(perfilInitial);

    useEffect(() => {
        buscarPerfiles(filtroPerfil);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChange = (e: any) => {
        e.preventDefault();
        setFiltroPerfil({
            ...filtroPerfil,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        buscarPerfiles(filtroPerfil);
    }

    const handleClean = () => {
        setFiltroPerfil(newPerfil);
    };

    return (
        <div className="card">
            <form id="dto" className="form-horizontal" action="buscarPermisos" method="post">
                <div className="card-body">
                    <h4 className="m-t-0 header-title">
                        <i className="fa fa-search margin-right-7" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                        Buscar
                    </h4>
                    <hr />
                    <div className="row">
                        <div className="col-md-4">
                            <label style={{ color: "grey" }}>
                                Descripción
                            </label>
                            <input id="descripcion" name="descripcion" className="form-control" type="text" value={filtroPerfil.descripcion} onChange={handleChange} />

                        </div>

                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-12 text-center">

                            <button className="btn btn-secondary btn-rounded waves-effect waves-light mr-1" type="button" id="limpiarFiltro" onClick={handleClean}>
                                <i className="fa fa-refresh mr-1" aria-hidden="true"></i>
                                Limpiar
                            </button>
                            <button className="btn btn-success btn-rounded waves-effect waves-light " type="submit" onClick={handleSubmit}>
                                <i className="fa fa-search mr-1"></i>
                                Buscar
                            </button>

                        </div>
                    </div>

                </div>
            </form>
        </div>
    )
}
